Wee.fn.make('gallery', {
	init: function() {
		var priv = this.$private,
			$galleryItem = $('ref:galleryItem'),
			hash = $._win.location.hash;

		$galleryItem.data('index', function(i) {
			return i;
		}).on('click', function(e, el) {
			priv.loadTarget($(el).data('index'));
		});

		if (hash) {
			var $member = $('a[href="' + hash + '"]');

			if ($member.length) {
				$.assets.load({
					img: $member.find('img').attr('src'),
					success: function() {
						priv.loadTarget($member.data('index'));
					}
				});
			}
		}

		priv.loadMore();
	},

	/**
	 * Unbind all company events
	 */
	unload: function() {
		$.events.off(false, '.gallery');

		if (Wee.app.gallery) {
			Wee.app.gallery.$destroy();
		}
	}
}, {
	/**
	 * Load member data from server
	 *
	 * @param {int} index
	 */
	loadTarget: function(index) {
		var scope = this;
		scope.index = index;

		if (! Wee.app.gallery) {
			scope.createTarget();
		}

		scope.$bio.addClass('-is-loading');

		scope.renderTarget(Wee.$get('gallery')[index]);
	},

	/**
	 * Render the member data into the application
	 *
	 * @param {object} data
	 */
	renderTarget: function(data) {
		this.positionTarget();

		Wee.app.gallery.$set(data);

		this.$bio.removeClass('-is-loading');
		this.$member.show();

		$.animate.tween($._body, {
			scrollTop: (this.$member.offset().top - $('ref:header').height()) - ($.screen.size() > 2 ? 15 : 20)
		});
	},

	/**
	 * Generate the bio structure on initial event
	 */
	createTarget: function() {
		var scope = this,
			$prev = $('<div class="gallery__nav -prev" />'),
			$next = $('<div class="gallery__nav -next" />'),
			$close = $('<div class="gallery__nav -close" />');
		scope.$member = $('<div class="gallery__item -featured" />');
		scope.$bio = $('<div class="gallery__featured" />');

		$prev.on('click', function() {
			scope.navigate();
		});

		$next.on('click', function() {
			scope.navigate(true);
		});

		$close.on('click', function() {
			scope.close();
		});

		$($._body).on('keydown', function(e) {
			if (e.keyCode == 37) {
				scope.navigate();
			} else if (e.keyCode == 39) {
				scope.navigate(true);
			} else if (e.keyCode == 27) {
				scope.close();
			}
		});

		scope.$member
			.append($prev)
			.append($next)
			.append($close)
			.append(scope.$bio)
			.appendTo('ref:gallery');

		$.app.make('gallery', {
			target: scope.$bio,
			view: 'gallery'
		});
	},

	/**
	 * Calculate and insert the bio before or after the current row
	 */
	positionTarget: function() {
		var $galleryItem = $('ref:galleryItem'),
			size = $.screen.size(),
			columns = 2;

		if (size > 3) {
			columns = 3;
		} else if (size > 2) {
			columns = 2;
		}

		var pos = (Math.ceil((this.index + 1) / columns) * columns) - 1;

		if (pos === $galleryItem.length) {
			pos = pos - columns;
		}

		this.$member.insertAfter(
			$galleryItem.eq(pos)
		);
	},

	/**
	 * Move forward or backwards through the members
	 *
	 * @param (next=false)
	 */
	navigate: function(next) {
		var $galleryItem = $('ref:galleryItem'),
			total = $galleryItem.length,
			index = 0;

		if (next) {
			index = this.index + 1 < total ? this.index + 1 : 0;
		} else {
			index = ! this.index ? total - 1 : this.index - 1;
		}

		this.loadTarget(index);
	},

	/**
	 * Close the currently open member detail
	 */
	close: function() {
		this.$member.hide();
	},

	/**
	 * Load more images
	 *
	 * @private
	 */
	loadMore: function() {
		var galleryArray = Array.from($('ref:galleryItem')),
			$more = $('ref:more'),
			index = 11;

		$more.on('click', function() {
			var start = index,
				end = start + 12;

			for (; start <= end; start++) {
				$('ref:galleryItem').eq(start).removeClass('-is-hidden');
			}

			index = start - 1;

			if (end >= galleryArray.length) {
				$more.hide();
			}
		}.bind(this));
	}
});